"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FieldsetContext = require("../context/FieldsetContext");

var LABEL_SIZE_OPTIONS = {
  default: '',
  small: 'private-form__label--small'
};

var UIFormLabel = _react.default.forwardRef(function (props, ref) {
  var className = props.className,
      error = props.error,
      readOnly = props.readOnly,
      required = props.required,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "error", "readOnly", "required"]);

  var _useContext = (0, _react.useContext)(_FieldsetContext.FieldsetContext),
      fieldSize = _useContext.size;
  /* eslint-disable jsx-a11y/label-has-associated-control */


  return _react.default.createElement("label", Object.assign({}, rest, {
    className: (0, _classnames.default)('private-form__label', LABEL_SIZE_OPTIONS[fieldSize], className, readOnly && 'private-form__label--readonly', required && 'private-form__label--required', error && 'error-msg'),
    ref: ref
  }));
  /* eslint-enable jsx-a11y/label-has-associated-control */
});

UIFormLabel.propTypes = {
  children: _propTypes.default.node,
  error: _propTypes.default.bool.isRequired,
  htmlFor: _propTypes.default.string,
  readOnly: _propTypes.default.bool.isRequired,
  required: _propTypes.default.bool.isRequired
};
UIFormLabel.defaultProps = {
  error: false,
  required: false,
  readOnly: false
};
UIFormLabel.displayName = 'UIFormLabel';
var _default = UIFormLabel;
exports.default = _default;
module.exports = exports.default;